import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#151613] text-[#f1e0c5] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-sm text-center space-y-4">
        <XCircle className="w-14 h-14 mx-auto text-[#f1e0c5]/40" />
        <h1 className="font-display text-3xl">Checkout Canceled</h1>
        <p className="text-sm text-[#f1e0c5]/60">No charge was made. You can try again anytime from your dashboard.</p>
        <Link to="/dashboard" data-testid="payment-cancel-dashboard-link" className="inline-block mt-2 text-[#D4AF37] underline text-sm">Back to Dashboard</Link>
      </div>
    </div>
  );
}
